import { ReactNode } from "react";
import { Breadcrumb } from "@/shared/widgets/breadcrumb";

interface PageContentProps {
  title: string;
  children: ReactNode;
  actions?: ReactNode;
  items?: Array<{ label: string; href: string }>;
  className?: string;
}

export function PageContent({ 
  title, 
  children, 
  actions, 
  items = [], 
  className = "" 
}: PageContentProps) {
  return (
    <div className={`flex flex-col w-full min-w-0 space-y-6 ${className}`}>
      <div className="flex-shrink-0">
        <Breadcrumb items={items} />
        <div className="flex justify-between items-center mt-4">
          <h1 className="text-2xl font-semibold text-white">{title}</h1>
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
      </div>
      <div className="flex-1 w-full min-w-0">
        {children}
      </div>
    </div>
  );
}
